module.exports = __webpack_public_path__ + "img/loclast_white_small.ab210ac9.svg";